import { useContext } from "react"
import { UserContext } from "./contexts"
import * as Iconoir from "iconoir-react"

interface UpgradeButtonProps {
  onClick: () => void
  plan?: any
}

const UpgradeButton = ({ onClick, plan }: UpgradeButtonProps) => {
  const user = useContext(UserContext)

  // Don't show for enterprise plan
  if (user.plan === "enterprise") {
    return null
  }

  const minutesLeft = plan?.minutes_remaining != null ? Math.ceil(plan.minutes_remaining) : null
  const isZeroMinutes = minutesLeft != null && minutesLeft <= 0

  // Different styling based on urgency
  if (user.plan === "freemium" && isZeroMinutes) {
    return (
      <div
        className="p-3 bg-red-50 border border-red-200 rounded-lg text-center cursor-pointer hover:bg-red-100 transition-colors"
        onClick={onClick}
      >
        <div className="flex items-center justify-center gap-2">
          <Iconoir.Crown className="w-5 h-5 text-red-600" />
          <h3 className="font-semibold text-sm text-red-800">Out of Minutes!</h3>
        </div>
        <p className="text-xs mt-1 text-red-700">Upgrade now to keep making calls</p>
      </div>
    )
  }

  if (user.plan === "freemium") {
    return (
      <div
        className="p-3 bg-indigo-50 border border-indigo-200 rounded-lg text-center cursor-pointer hover:bg-indigo-100 transition-colors"
        onClick={onClick}
      >
        <div className="flex items-center justify-center gap-2">
          <Iconoir.Crown className="w-5 h-5 text-indigo-600" />
          <h3 className="font-semibold text-sm text-indigo-800">Upgrade Now</h3>
        </div>
        <p className="text-xs mt-1 text-indigo-700">
          {minutesLeft === null ? "Loading..." : `${minutesLeft} free call minutes left`}
        </p>
      </div>
    )
  }

  // For paid plans that can still upgrade
  return (
    <div
      className="p-3 bg-purple-50 border border-purple-200 rounded-lg text-center cursor-pointer hover:bg-purple-100 transition-colors"
      onClick={onClick}
    >
      <div className="flex items-center justify-center gap-2">
        <Iconoir.Crown className="w-5 h-5 text-purple-600" />
        <h3 className="font-semibold text-sm text-purple-800">Upgrade Plan</h3>
      </div>
      <p className="text-xs mt-1 text-purple-700">Unlock more features & call capacity</p>
    </div>
  )
}

export default UpgradeButton
